<!-- 种类列表    background-color="#ffffff"-->
<template>
  <div class="nav">
    <el-menu
      :default-active="active"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      :unique-opened="true"
      background-color="#ffffff"
      text-color="#3d4148"
      active-text-color="#165dff"
    >
      <template v-for="item in navData">
        <!-- 一级导航 -->
        <el-menu-item
          :index="item.id"
          v-if="!item.children && !item.hide"
          :key="item.id"
          @click="itemBtn(item)"
        >
          <i :class="item.icon"></i>
          <span slot="title">{{ item.label }}</span>
        </el-menu-item>
        <!-- 存在二级的一级导航 -->
        <el-submenu :index="item.id" :key="item.id + 1" v-if="item.children && !item.hide">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.label }}</span>
          </template>
          <!-- 二级 -->
          <div v-for="(item_next, index_next) in item.children" :key="index_next">
            <el-menu-item
              :index="item_next.id"
              v-if="!item_next.children && !item_next.hide"
              @click="itemBtn(item_next)"
            >
              <span slot="title">{{ item_next.label }}</span>
            </el-menu-item>
            <!-- 存在三级的二级导航 -->
            <el-submenu :index="item_next.id" v-if="item_next.children && !item_next.hide">
              <span slot="title">{{ item_next.label }}</span>
              <!-- 三级 -->
              <template v-for="(item_next_next, index_next_next) in item_next.children">
                <el-menu-item
                  v-if="!item_next_next.hide"
                  :key="index_next_next"
                  :index="item_next_next.id"
                  @click="itemBtn(item_next_next)"
                >{{ item_next_next.label }}</el-menu-item>
              </template>
            </el-submenu>
          </div>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { loginOutApi } from "@/services/admin_user/index";
import { mapState } from "vuex";

export default {
  name: "Nav",
  components: {},
  props: {
    isCollapse: {
      type: Boolean,
      default: true
    },
    navData: {
      type: Array
    },
    active: {
      type: String
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["userInfo"])
  },
  methods: {
    itemBtn(item, index) {
      this.$emit("clickNav", item, index);
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    /* 退出账户 */
    tuichuBtn() {
      this.$confirm("我们会保留您的账户数据，是否确认退出?", "退出登录", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$router.push({ name: "Login" });
        loginOutApi({ id: this.userInfo.id }).then(resp => {
          this.$message({
            type: "success",
            message: "已安全退出账户!"
          });
        });
      });
    },
  }
};
</script>

<style scoped lang="less">
.nav {
  width: 100%;
  height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;

  .el-menu-vertical-demo {
    flex: 1;
    overflow-y: auto;
    border-right: none;
  }

  /* 底部功能区 */
  .nav-bottom {
    flex-shrink: 0;
    border-top: 1px solid #ffffff;
    background: #ffffff;

    .nav-user {
      display: flex;
      align-items: center;
      padding: 15px 12px;
      cursor: pointer;
      transition: all 0.3s;
      border-top: 1px solid #e5e7eb;

      &:hover {
        background-color: #f2f3f5;
      }

      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        flex-shrink: 0;
      }

      .user-info {
        margin-left: 10px;
        flex: 1;
        overflow: hidden;

        .user-role {
          font-size: 12px;
          color: #999;
          line-height: 1.4;
        }

        .user-name {
          font-size: 14px;
          color: #3d4148;
          font-weight: 500;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

// .el-menu-vertical-demo:not(.el-menu--collapse) {
//   width: 200px;
//   min-height: 400px;
// }
/* 菜单选中后的颜色 */

/deep/ .el-submenu__title {
  &:hover {
    background-color: #eaf2ff !important;
    border-radius: 8px;
  }
}

.el-menu .el-menu-item {
  position: relative;
  margin: 0 8px;
  border-radius: 8px;
  color: #3d4148;
  transition: color 0.18s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 8px;
    background-color: #3D8DFC;
    opacity: 0;
    transition: opacity 0.18s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 0;
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }
}

/* 父级菜单（有子级）与叶子项保持同样的左右间距，避免图标错位 */
.el-menu .el-submenu {
  margin: 0 8px;
  border-radius: 8px;
}

.el-menu .el-menu-item.is-active {
  color: #fff !important;

  &::before {
    opacity: 1;
  }
}

/* 点击二级菜单时多出的一像素边框问题 */
.el-menu {
  border-right: none;
}

/* 子菜单hover颜色处理 */
.el-menu-item:not(.is-active):hover {
  background-color: #eaf2ff !important;
  border-radius: 8px;
}

/* 菜单图标对齐：统一尺寸 + 垂直居中，使文字起点一致 */
/deep/ .el-menu-item,
/deep/ .el-submenu__title {
  display: flex;
  align-items: center;
}
/deep/ .el-menu-item > i,
/deep/ .el-submenu__title > i {
  flex-shrink: 0;
  width: 18px;
  text-align: center;
  margin-right: 10px;
  font-size: 17px;
}
</style>
